import React, { useState } from "react";
import { ChevronDown, CircleCheck, ExternalLink, User } from "lucide-react";

// Ligne de Timeline écrite automatiquement par le serveur à la clôture d'une
// tâche (Suivi prod, Traitements comptables — backend
// services/timelineSuivi.js) : origine, auteur, description et détail
// dépliable (details.lignes / details.liens).

const SOURCES = {
  traitements_comptables: "Traitements comptables",
  suivi_bilan: "Bilan",
  suivi_ago: "Juridique AGO",
  suivi_tva: "TVA",
  suivi_tva_rsi: "TVA RSI",
  suivi_is: "IS",
  suivi_cfe: "CFE",
  suivi_social: "Social",
  suivi_compta: "Suivi Compta",
  mission_juridique: "Juridique ponctuelle",
  liaison_acd: "Liaison ACD",
  revue_lab: "Revue LAB",
};

export const estLigneAuto = (hist) => !!hist?.source;

export default function TimelineAuto({ hist }) {
  const [ouvert, setOuvert] = useState(false);
  const lignes = Array.isArray(hist.details?.lignes) ? hist.details.lignes : [];
  const liens = Array.isArray(hist.details?.liens) ? hist.details.liens : [];
  const aDetail = lignes.length > 0 || liens.length > 0;

  return (
    <div className="mt-1 space-y-1.5">
      <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
        <span className="inline-flex items-center gap-1 rounded-full bg-[#840040]/10 px-2 py-0.5 text-[11px] font-semibold text-[#840040]">
          <CircleCheck className="h-3 w-3" aria-hidden="true" />
          {SOURCES[hist.source] || "Suivi"}
        </span>
        {hist.auteur && (
          <span className="inline-flex items-center gap-1 text-[11px] text-slate-600">
            <User className="h-3 w-3" aria-hidden="true" />
            {hist.auteur}
          </span>
        )}
      </div>

      {hist.description && <p className="text-xs leading-relaxed text-slate-700">{hist.description}</p>}

      {aDetail && (
        <button
          type="button"
          onClick={() => setOuvert((o) => !o)}
          aria-expanded={ouvert}
          className="inline-flex items-center gap-1 text-xs font-medium text-[#840040] hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#840040] rounded"
        >
          {ouvert ? "Masquer le détail" : "Voir le détail"}
          <ChevronDown className={`h-3.5 w-3.5 transition-transform ${ouvert ? "rotate-180" : ""}`} aria-hidden="true" />
        </button>
      )}

      {ouvert && (
        <div className="rounded-md border border-slate-200 bg-white p-2.5">
          {lignes.length > 0 && (
            <dl className="grid grid-cols-[minmax(0,42%)_minmax(0,1fr)] gap-x-3 gap-y-1 text-xs">
              {lignes.map((l, i) => (
                <React.Fragment key={`${l.libelle}-${i}`}>
                  <dt className="text-slate-500">{l.libelle}</dt>
                  <dd className="whitespace-pre-line break-words text-slate-800">{l.valeur}</dd>
                </React.Fragment>
              ))}
            </dl>
          )}
          {liens.length > 0 && (
            <div className={`flex flex-wrap gap-2 ${lignes.length ? "mt-2 border-t border-slate-100 pt-2" : ""}`}>
              {liens.map((l, i) => (
                <a
                  key={`${l.url}-${i}`}
                  href={l.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1 rounded border border-slate-200 px-2 py-0.5 text-xs font-medium text-[#840040] hover:bg-[#840040]/5"
                >
                  <ExternalLink className="h-3 w-3" aria-hidden="true" />
                  {l.libelle}
                </a>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
